import { InjectionToken } from "@angular/core";

export const VIDEO_PROFILE_TEMPLATES = new InjectionToken("VIDEO_PROFILE_TEMPLATES");

export const videoProfilePresetData = [
    {
        name: "XDCAM422HD/MXF/1080i/59.94",
        data: {
            videoFormat: "Sony XDCAM-HD 422",
            fileContainer: "MXF",
            videoStandard: "1080i",
            frameRate: 59.94,
        },
    },
    {
        name: "XDCAM/MXF/1080i/59.94",
        data: {
            videoFormat: "XDCAM",
            fileContainer: "MXF",
            videoStandard: "1080i",
            frameRate: 59.94,
        },
    },
    {
        name: "HDCAM/1080i/59.94",
        data: {
            videoFormat: "HDCAM",
            fileContainer: "",
            videoStandard: "1080i",
            frameRate: 59.94,
        },
    },
    {
        name: "IMX-50/MOV/NTSC/29.97DF",
        data: {
            videoFormat: "IMX-50",
            fileContainer: "MOV",
            videoStandard: "NTSC",
            frameRate: 29.97,
        },
    },
    {
        name: "IMX-50/MXF/NTSC/29.97",
        data: {
            videoFormat: "IMX-50",
            fileContainer: "MXF",
            videoStandard: "NTSC",
            frameRate: 29.97,
        },
    },
    {
        name: "SDIMX-30/MXF/NTSC/29.97",
        data: {
            videoFormat: "SD IMX-30",
            fileContainer: "MXF",
            videoStandard: "NTSC",
            frameRate: 29.97,
        },
    },
    {
        name: "AppleProRes422HQ/MOV/1080p/23.98",
        data: {
            videoFormat: "Apple ProRes 422",
            fileContainer: "MOV",
            videoStandard: "1080p",
            frameRate: 23.98,
        },
    },
    {
        name: "AppleProRes422HQ/MOV/1080i/59.94",
        data: {
            videoFormat: "Apple ProRes 422",
            fileContainer: "MOV",
            videoStandard: "1080i",
            frameRate: 59.94,
        },
    },
    {
        name: "AppleProRes422Hq/MOV/720p/59.94",
        data: {
            videoFormat: "Apple ProRes 422",
            fileContainer: "MOV",
            videoStandard: "720p",
            frameRate: 59.94,
        },
    },
];

export const videoProfilePresetProvider = {
    provide: VIDEO_PROFILE_TEMPLATES,
    useValue: videoProfilePresetData,
};
